<template>
    <el-form style="height:10px;margin-top:-20px">
        <el-form-item>
            <td-tree-select
                ref="tdTree"
                :interfaceName="interfaceName"
                :calInternal="true"
                :inputShow="true"
                :lazyloading="true"
                :nodeKey="nodekey"
                :multiple="false"
                :checkStrictly="false"
                :isPaging="true"
                :params="params"
                :imgloading="true"
                :defaultProps="deviceProps"
                :isSingleCheck="true"
                :filter="userTreeFilter"
                @isChosenSimple="clickNode"
                @handleClose="handleClose"
                v-model="item"
            ></td-tree-select>
        </el-form-item>
    </el-form>
</template>
<script>
export default {
    props: {
        title: {
            type: [String, Number]
        },
        editItem: {
            type: Object
        },
        // 页面是否显示
        isImportVisible: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 设备类型
        iDeviceTypes: {
            type: Array,
            default: function() {
                return [];
            }
        },
        fileParam: {
            type: Object
        },
        // 组织id
        orgId: {
            type: String
        }
    },
    computed: {},
    mounted() {},
    data() {
        return {
            interfaceName: { query: '/staffManager/queryStaffOrgTree', search: '/staffManager/getStaffInfoByCaption' },
            deviceProps: {
                children: 'children',
                label: 'caption',
                id: 'id',
                imgName: 'sIcon',
                parentId: 'parentId'
            },
            item: '',
            params: {
                includeSelf: true, // 查询条件是否包含自己
                parentId: '',
                rootCodes: this.$common.initOrgTreeParam.SCODE,
                orgTypeIds: this.$common.initOrgTreeParam.ORGTYPEIDS,
                deviceTypeList: this.parentDevType
            },
            userList: [],
            lazyloading: false,
            defaultProps: {
                children: 'children',
                label: 'caption',
                id: 'id',
                imgName: 'sIcon',
                parentId: 'parentId'
            },
            isSingleCheck: false,
            multiple: true,
            inputShow: true,
            nodekey: 'id',
            fromOrgImport: {},
            staffId: '',
            loading: false
        };
    },
    methods: {
        clickNode(data) {
            if (this.$util.isEmpty(data.staffId)) {
                this.$refs.tdTree.areaUserList.splice(0, 1);
                this.$message({ showClose: true, message: this.$t('pgMessage.ONLY_STAFF'), type: 'warning' });
                return;
            } else if (this.editItem != null && this.editItem != undefined && data.staffId == this.editItem.staffId) {
                this.$refs.tdTree.areaUserList.splice(0, 1);
                this.$message({ showClose: true, message: this.$t('pgMessage.CAN_NOT_SELECT_SELF'), type: 'warning' });
                return;
            }
            this.$emit('clickChosen', data);
        },
        handleClose(data) {
            this.$emit('handleClose', data);
        },
        dataDisplay(data) {
            this.$refs.tdTree.areaUserList.push(data);
        }
    }
};
</script>
